import { IFormFields } from '@components/ui-upsert-page/ui-form.component';
import { IQueueUpsert } from '@models';

export const UPSERT_QUEUE_FIELDS: IFormFields<IQueueUpsert> = {
    id: 'id',
    name: 'name',
    description: 'description',
    maxNoOfRetries: 'maxNoOfRetries',
    acceptAutoRetry: 'acceptAutoRetry',
    enforceUniqueReference: 'enforceUniqueReference',
    specificDataJsonSchema: 'specificDataJsonSchema',
    outputDataJsonSchema: 'outputDataJsonSchema',
    analyticsDataJsonSchema: 'analyticsDataJsonSchema',
    slaMinutes: 'slaMinutes',
    riskSlaMinutes: 'riskSlaMinutes',
    releaseId: 'releaseId',
    triggerId: 'triggerId',
    releaseKey: 'releaseKey',
};
